
import { newsItems } from '../../../mocks/news';
import { Link } from 'react-router-dom';

export default function News() {
  // Guard against missing or empty data
  if (!Array.isArray(newsItems) || newsItems.length === 0) {
    return (
      <section id="news" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-16 tracking-tight">
            NEWS
          </h2>
          <p className="text-gray-500">ニュースは現在ありません。</p>
        </div>
      </section>
    );
  }

  return (
    <section id="news" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 tracking-tight">
          NEWS
        </h2>

        <div className="max-w-4xl mx-auto space-y-0">
          {newsItems.slice(0, 5).map((item) => (
            <Link
              key={item.id}
              to={`/news/detail?id=${item.id}`}
              className="block border-t border-gray-200 py-8 hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <time className="text-sm text-gray-500 font-medium md:w-32 flex-shrink-0">
                  {item.date}
                </time>
                <div className="flex-1">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <span className="inline-block px-3 py-1 bg-gray-100 text-xs font-medium text-gray-700 rounded-full">
                    {item.category}
                  </span>
                </div>
                <i className="ri-arrow-right-line text-xl text-gray-400 hidden md:block"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/news"
            className="inline-flex items-center gap-2 px-8 py-3 border border-gray-900 text-sm font-medium text-gray-900 rounded-lg hover:bg-gray-900 hover:text-white transition-colors whitespace-nowrap"
          >
            ニュース一覧を見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
